/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useState } from "react";
import { useGLTF, useTexture } from "@react-three/drei";
import { subsystems } from "../utils/constant";
import { useSnapshot } from "valtio";
import state from "../state";
import * as THREE from "three";
import { handleHeight } from "../utils/constant";
import classy from "../assets/models/classy.glb";
import { ClassyGlassCount } from "../models/DivCount";
import { GetHandleColor } from "./GetHandleColor";
import { xrepeat, yrepeat } from "../utils/constant";
import ClassyHandle from "./ClassyHandle";

export default function Profile(props) {
  const { nodes, materials } = useGLTF(classy);
  const { px, py, width, height, systemID, glassCount } = props;
  const [opacity, setOpacity] = useState(0.3);
  const [color, setColor] = useState("#a7c7cb");
  const snap = useSnapshot(state);

  const int_width = subsystems[systemID].width;
  const int_height = subsystems[systemID].height;
  const sw = width / int_width;
  const sh = height / int_height;

  const texture = useTexture(snap.structure.textureA);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(xrepeat * 70, yrepeat * 70);
  const material_texture = new THREE.MeshPhysicalMaterial({
    map: texture,
  });

  return (
    <group
      rotation={props.rotation}
      scale={props.scale * 0.1}
      // position={[px * unit, py * unit, pz * unit]}
      // position={[px + width * unit / 2, pz, py]}
      position={[px, 0, py - 0.06]}
    >
      <group
        rotation={[Math.PI / 2, -Math.PI / 2, 0]}
        position={[-90, width / 2, 0]}
      >
        <group scale={[1, 1, 1]} position={[0, 0, 0]}>
          <mesh
            geometry={nodes.topprofile.geometry}
            material={props.isTexture ? material_texture : materials.profile}
            position={[0, height, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={[sw, 1, 1]}
            material-color={snap.structure.color}
          />
          <mesh
            geometry={nodes.bottomprofile.geometry}
            material={props.isTexture ? material_texture : materials.profile}
            position={[0, 0, 0]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={[sw, 1, 1]}
            material-color={snap.structure.color}
          />
          <mesh
            geometry={nodes.leftprofile.geometry}
            material={props.isTexture ? material_texture : materials.profile}
            position={[-width / 2, height / 2, 0]}
            rotation={[-Math.PI / 2, Math.PI / 2, 0]}
            scale={[sh, 1, 1]}
            material-color={snap.structure.color}
          />
          <mesh
            geometry={nodes.rightprofile.geometry}
            material={props.isTexture ? material_texture : materials.profile}
            position={[width / 2, height / 2, 0]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
            scale={[sh, 1, 1]}
            material-color={snap.structure.color}
          />
        </group>
      </group>
    </group>
  );
}

// useGLTF.preload('models/classy8.glb')
